var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoVerdeTmovgr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 193,
    height: 40,
    viewBox: "0 0 193 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4143_16924)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 14.8775L6.24245 8.71474C8.00882 6.97056 10.4051 5.99072 12.9032 5.99072H35.9268V14.8258L23.8417 14.8424V38.5148H14.8925V14.8566L0 14.8775Z",
    fill: "#24A95D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.5788 13.5984C103.412 13.5984 107.344 17.4806 107.344 22.2525C107.344 27.0244 103.412 30.9066 98.5788 30.9066C93.7454 30.9066 89.8131 27.0244 89.8131 22.2525C89.8131 17.4806 93.7454 13.5984 98.5788 13.5984ZM98.5788 4.51758C88.6579 4.51758 80.6152 12.4579 80.6152 22.2525C80.6152 32.0472 88.6579 39.9875 98.5788 39.9875C108.5 39.9875 116.542 32.0472 116.542 22.2525C116.542 12.4579 108.5 4.51758 98.5788 4.51758Z",
    fill: "#24A95D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.561 5.99072L147.082 9.4671L130.316 26.0198V5.99072H120.924V38.5148H126.414C128.913 38.5148 131.309 37.535 133.075 35.7905L153.411 15.7146L156.932 19.191V5.99072H143.561Z",
    fill: "#24A95D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.2721 14.8903L64.5276 8.71474C66.294 6.97056 68.69 5.99072 71.1887 5.99072H76.2357V38.5148H67.2864V18.6101L58.2721 27.5097L49.2578 18.6101V38.5148H40.3086V5.99072H45.3559C47.8543 5.99072 50.2503 6.97056 52.017 8.71474L58.2721 14.8903Z",
    fill: "#24A95D"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M167.472 8.946H169.544V12.922C169.012 13.3233 168.396 13.6313 167.696 13.846C166.996 14.0607 166.291 14.168 165.582 14.168C164.564 14.168 163.65 13.9533 162.838 13.524C162.026 13.0853 161.386 12.4833 160.92 11.718C160.462 10.9433 160.234 10.0707 160.234 9.1C160.234 8.12933 160.462 7.26133 160.92 6.496C161.386 5.72133 162.03 5.11933 162.852 4.69C163.673 4.25133 164.597 4.032 165.624 4.032C166.482 4.032 167.262 4.17667 167.962 4.466C168.662 4.75533 169.25 5.17533 169.726 5.726L168.27 7.07C167.57 6.33267 166.725 5.964 165.736 5.964C165.11 5.964 164.555 6.09467 164.07 6.356C163.584 6.61733 163.206 6.986 162.936 7.462C162.665 7.938 162.53 8.484 162.53 9.1C162.53 9.70667 162.665 10.248 162.936 10.724C163.206 11.2 163.58 11.5733 164.056 11.844C164.541 12.1053 165.092 12.236 165.708 12.236C166.361 12.236 166.949 12.096 167.472 11.816V8.946ZM179.294 14L177.404 11.27H177.292H175.318V14H173.05V4.2H177.292C178.16 4.2 178.912 4.34467 179.546 4.634C180.19 4.92333 180.685 5.334 181.03 5.866C181.376 6.398 181.548 7.028 181.548 7.756C181.548 8.484 181.371 9.114 181.016 9.646C180.671 10.1687 180.176 10.57 179.532 10.85L181.73 14H179.294ZM179.252 7.756C179.252 7.20533 179.075 6.78533 178.72 6.496C178.366 6.19733 177.848 6.048 177.166 6.048H175.318V9.464H177.166C177.848 9.464 178.366 9.31467 178.72 9.016C179.075 8.71733 179.252 8.29733 179.252 7.756Z",
    fill: "#24A95D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4143_16924"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 156.979,
    height: 35.6771,
    fill: "white",
    transform: "translate(0 4.32275)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoVerdeTmovgr);
export default __webpack_public_path__ + "static/media/logo-verde-tmovgr.fc4fddc268e8834023d96e29189ae45c.svg";
export { ForwardRef as ReactComponent };